import { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const SwapMDN = () => {
  const [formData, setFormData] = useState({
    type: 'ChangePlan',
    mdn: '',
    sim: '',
    newplanID: '' ,
     newZip: '', // Add this line
    e911ADDRESS: {
      streeT1: "string",
      streeT2: "string",
      city: "string",
      state: "string",
      zip: "94105"
    }
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch('https://pwg.clay.in/api/Pwg/SwapPlan', {
        method: 'POST',
        headers: {
          'accept': '*/*',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          request: formData
        })
      });

      const result = await response.json();

      // Show toast notification based on response data
      if (result.success) {
        const { timestamp, status, type, newMdn } = result.data;
        
        let message = '';
        let toastType = 'info';

        if (status === 'success') {
          toastType = 'success';
          message = `MDN Swap Successful!`;
          if (newMdn) message += ` New MDN: ${newMdn}`;
          if (type) message += ` Type: ${type}`;
        } else if (status === 'failure') {
          toastType = 'error';
          message = `MDN Swap Failed`;
          if (type) message += ` - ${type}`;
        }

        // Add timestamp info
        if (timestamp) {
          message += ` (${formatTimestamp(timestamp)})`;
        }

        // Show appropriate toast
        switch (toastType) {
          case 'success':
            toast.success(message);
            break;
          case 'error':
            toast.error(message);
            break;
          default:
            toast.info(message);
        }

      } else {
        toast.error('Request failed: API returned unsuccessful response');
      }

    } catch (error) {
      toast.error(`Network error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // Helper function to format timestamp
  const formatTimestamp = (timestamp) => {
    try {
      // Assuming timestamp is in format YYYYMMDDHHMMSS
      const year = timestamp.substring(0, 4);
      const month = timestamp.substring(4, 6);
      const day = timestamp.substring(6, 8);
      const hour = timestamp.substring(8, 10);
      const minute = timestamp.substring(10, 12);
      const second = timestamp.substring(12, 14);
      
      return `${day}-${month}-${year} ${hour}:${minute}:${second}`;
    } catch (error) {
      return timestamp; // Return original if parsing fails
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md mx-auto bg-white rounded-lg shadow-md p-6">
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">
          MDN Swap Request
        </h2>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Type
            </label>
            <input
              type="text"
              name="type"
              value={formData.type}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter type"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              MDN
            </label>
            <input
              type="text"
              name="mdn"
              value={formData.mdn}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter MDN"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              SIM
            </label>
            <input
              type="text"
              name="sim"
              value={formData.sim}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter SIM"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              New Plan ID
            </label>
            <input
              type="text"
                name="newplanID"  // Changed from "New Plan ID" to "newplanID"
              value={formData.newplanID}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter new plan ID"  // Also fixed the placeholder text
            />
          </div>

<div>
  <label className="block text-sm font-medium text-gray-700 mb-1">
    New ZIP
  </label>
  <input
    type="text"
    name="newZip"  // Make sure this matches the state property
    value={formData.newZip}
    onChange={handleChange}
    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
    placeholder="Enter new ZIP code"
  />
</div>

          <button
            type="submit"
            disabled={loading}
            className={`w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white ${
              loading 
                ? 'bg-gray-400 cursor-not-allowed' 
                : 'bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500'
            }`}
          >
            {loading ? 'Processing...' : 'Swap MDN'}
          </button>
        </form>
      </div>

      {/* Toast Container */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
};

export default SwapMDN;